import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-number-box";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
function TagServerViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Server() || Bao.Utils.String.IsNullOrEmpty(self.Label()))) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(TagServerViewModel, SearchPaging);
TagServerViewModel.prototype.PrimaryKey = "TagServerId";
TagServerViewModel.prototype.RefreshUrl = "MasterData/TagServer/Get";
TagServerViewModel.prototype.SaveUrl = "MasterData/TagServer/Save";
TagServerViewModel.prototype.DeleteUrl = "MasterData/TagServer/Delete";
TagServerViewModel.prototype.IsInUseUrl = "MasterData/TagServer/IsInUse";
TagServerViewModel.prototype.PermissionForward = "TagServerMoveForward";
TagServerViewModel.prototype.PermissionBackward = "TagServerMoveBackward";
TagServerViewModel.prototype.PermissionSave = "TagServerSave";
TagServerViewModel.prototype.PermissionRefresh = "TagServerRefresh";
TagServerViewModel.prototype.PermissionDelete = "TagServerDelete";
export default TagServerViewModel;